export default "__VITE_PUBLIC_ASSET__90922f0d__"